// Form validation for New Client form
import {
  emailValidator,
  nameValidator,
  phoneValidator,
  plaintextValidator
} from '../fields';

const config = { mandatory: true };

export const clientConstraints = {
  name: plaintextValidator(config),
  'primaryContact.firstName': nameValidator(config),
  'primaryContact.lastName': nameValidator(config),
  // 'primaryContact.phoneNumber': phoneValidator(config),
  'primaryContact.email': emailValidator(config),
  // 'secondaryContact.firstName': nameValidator(config),
  // 'secondaryContact.lastName': nameValidator(config),
  // 'secondaryContact.phoneNumber': phoneValidator(config),
  // 'secondaryContact.email': emailValidator(config),
  'site.name': plaintextValidator(config),
  'site.timezoneCode': plaintextValidator(config)
  // 'site.address': plaintextValidator(config),
  // 'site.country': nameValidator(config),
  // 'site.state': nameValidator(config)
};

export const clientContactConstraints = {
  'secondaryContact.firstName': nameValidator(config),
  'secondaryContact.lastName': nameValidator(config),
  // 'secondaryContact.phoneNumber': phoneValidator(config),
  'secondaryContact.email': emailValidator(config)
};
